/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_QtyInputs */



/**
* | output |
* | --- |
* | "Copies distributed" |
*
* @param {Promos_QtyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_qty = /** @type {((inputs?: Promos_QtyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_QtyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copies distribuées")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copias distribuidas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cópias distribuídas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copie distribuite")
	return /** @type {LocalizedString} */ ("Copies distributed")
});